// src/routes/config/Public.tsx

import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import ForgotPassword from "../../features/auth/ForgotPassword";
import { Unauthorized, NotFound, LandingPage } from "../../pages";

const Login = lazy(() => import("../../features/auth/AuthPage"));
const Signup = lazy(() => import("../../features/auth/SignupPage"));

export const Public: RouteObject[] = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "*",
    element: <NotFound />,
  },

];